import React, { useMemo } from 'react';
// components
import AsyncSelect from 'shared/inputs/AsyncSelect';
import { hitGetEndpoint } from 'src/fetch/general';

const FixedValueAsyncSelectLookup = ({
  fixedValueProps, name, value, displayValue, setDisplayValue, setFieldValue, readOnly,
}) => {
  const { endpoint, lookupValueName, lookupDisplayName } = fixedValueProps;
  const hasSearchParams = endpoint.includes('?');

  const innerValue = useMemo(() => ({
    [lookupValueName || 'id']: Number(value),
    [lookupDisplayName || 'name']: displayValue
  }), [value, displayValue]);

  return (
    <AsyncSelect
      name={name}
      getData={(search) => {
        const result = hasSearchParams && search && search !== '' ? `${endpoint}&search=${search}` : endpoint;
        return hitGetEndpoint({ endpoint: result })();
      }}
      dataItemKey={lookupValueName || 'id'}
      textField={lookupDisplayName || 'name'}
      onChange={({ value }) => {
        setFieldValue(value[lookupValueName || 'id']);
        setDisplayValue(value[lookupDisplayName || 'name']);
      }}
      value={innerValue}
      readOnly={readOnly}
    />
  );
};

export default FixedValueAsyncSelectLookup;
